import React, { createContext, useState, useContext, useCallback } from 'react';
import { normalizeBusinessRecord } from '../services/api';

const BusinessContext = createContext();

export function BusinessProvider({ children }) {
  const [currentBusiness, setCurrentBusiness] = useState(() => {
    const stored = localStorage.getItem('currentBusiness');
    if (!stored) return null;
    try {
      return normalizeBusinessRecord(JSON.parse(stored));
    } catch {
      return null;
    }
  });

  const updateBusiness = useCallback((business) => {
    setCurrentBusiness(prev => {
      const next = typeof business === 'function' ? business(prev) : business;
      const normalized = normalizeBusinessRecord(
        next,
        next?.business_id || next?.id || prev?.business_id || prev?.id,
      );
      if (normalized) {
        localStorage.setItem('currentBusiness', JSON.stringify(normalized));
      } else {
        localStorage.removeItem('currentBusiness');
      }
      return normalized;
    });
  }, []);

  return (
    <BusinessContext.Provider value={{ 
      currentBusiness, 
      setCurrentBusiness: updateBusiness 
    }}>
      {children}
    </BusinessContext.Provider>
  );
}

export function useBusiness() {
  const context = useContext(BusinessContext);
  if (!context) {
    throw new Error('useBusiness must be used within a BusinessProvider');
  }
  return context;
}